var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 34,
    viewBox: "0 0 31 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29608 24.0575C4.42236 26.4852 2.54955 28.9131 0.674944 31.3408C0.179398 31.9817 0.166659 32.7198 0.648108 33.2401C1.12637 33.757 1.77244 33.7487 2.35331 33.2164C3.95933 31.7485 5.56397 30.2804 7.16979 28.812C7.90137 28.1417 8.63505 27.4725 9.39645 26.7763C8.45719 25.7374 7.53639 24.7177 6.59784 23.6799C6.48186 23.8256 6.38727 23.94 6.29608 24.0575ZM19.4723 33.5718C20.8145 31.9208 20.7522 29.0714 19.5485 25.8933C19.5733 25.8438 19.6012 25.7939 19.637 25.7423C22.36 21.7416 25.0667 17.7291 27.7783 13.7197L28.151 14.1291C28.7571 14.7935 29.7392 14.793 30.3444 14.1288L30.5459 13.9086C31.1511 13.2446 31.1516 12.1678 30.5461 11.5031L20.5114 0.497862C19.9053 -0.166091 18.9239 -0.1659 18.3179 0.49811L18.1171 0.718107C17.5117 1.38206 17.5117 2.45986 18.1171 3.12387L18.6329 3.69057C14.9269 6.66329 11.2221 9.6372 7.50887 12.5982C7.50523 12.6017 7.49979 12.6039 7.49524 12.6064C4.52424 11.2258 1.80201 11.0891 0.341231 12.6912C0.172034 12.8765 -0.293244 13.4629 0.270961 14.082L18.1321 33.671C18.7573 34.3569 19.2713 33.7921 19.4723 33.5718ZM12.5681 16.0477C11.8096 15.368 11.041 14.7589 10.2745 14.2243C13.5634 11.2788 16.851 8.3328 20.1631 5.36654L21.896 7.2672C18.7665 10.213 15.6659 13.131 12.5681 16.0477Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/PinIcon.83cce606f7c783b69484adda208d7e09.svg";
export { ForwardRef as ReactComponent };